export const getBackgroundById = (id: number): string => {
    let image = '';

    switch (id) {
        case 21:
            image = 'gaming';
            break;
        case 51:
            image = 'entertainment';
            break;
        case 131:
            image = 'giga';
            break;
        case 150:
            image = 'lesta';
            break;
        default:
            image = 'default';
            break;
    }

    return `/static/images/multiPackageCard/bg/${image}.png`;
};
